import { Paper } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { PagedRequest, QueryField } from 'src/store';
import { Props } from '../../container';
import { ReportingSchedulerTable } from './ReportingSchedulerTable';

export const ReportingScheduler = (props: Props): JSX.Element => {
  const [pagedRequest, setPagedRequest] = useState<PagedRequest>({
    pageNumber: 1,
    pageSize: 100,
    queryFields: [] as QueryField[],
  });

  const handlePagedRequest = useCallback((newRequest: PagedRequest) => {
    setPagedRequest(newRequest);
  }, []);

  useEffect(() => {
    props.fetchScheduledEventList({
      page: pagedRequest.pageNumber - 1,
      pageSize: pagedRequest.pageSize,
      queryFields: pagedRequest.queryFields,
    });
  }, [pagedRequest]);

  const deleteScheduledEvent = (id: string) => {
    props
      .deleteScheduledEvent(id)
      .unwrap()
      .then(() => {
        props.fetchScheduledEventList({
          page: pagedRequest.pageNumber - 1,
          pageSize: pagedRequest.pageSize,
          queryFields: pagedRequest.queryFields,
        });
      });
  };

  return (
    <Paper elevation={4}>
      <ReportingSchedulerTable
        fetchScheduledEventListProgress={props.fetchScheduledEventListProgress}
        paginatedEventListResults={props.reporting.bulk.paginatedEventListResults}
        deleteScheduledEventProgress={props.deleteScheduledEventProgress}
        deleteScheduledEvent={deleteScheduledEvent}
        pagedRequest={pagedRequest}
        handlePagedRequest={handlePagedRequest}
      />
    </Paper>
  );
};
